(function() {
  const waitForProductMedia = setInterval(() => {
    const originalProductMedia = customElements.get('product-media');
    if (!originalProductMedia) return;
    
    clearInterval(waitForProductMedia);
    
    // Firefox Detection
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    console.log(isFirefox ? '🦊 Firefox' : '✅ Chrome');
    
    let currentGalleryKey = null;
    
    async function filterGallery(productMedia, variantId, isInitialLoad = false) {
      const variantGalleriesAttr = productMedia.getAttribute('data-variant-galleries');
      const mediaFilenamesAttr = productMedia.getAttribute('data-media-filenames');
      
      if (!variantGalleriesAttr || !mediaFilenamesAttr) return;
      
      try {
        const variantGalleries = JSON.parse(variantGalleriesAttr);
        const mediaFilenames = JSON.parse(mediaFilenamesAttr);
        const galleryFilenames = variantGalleries[variantId.toString()] || [];
        
        const newGalleryKey = galleryFilenames.join(',');
        if (!isInitialLoad && newGalleryKey === currentGalleryKey) {
          return;
        }
        currentGalleryKey = newGalleryKey;
        
        console.log('🎨 Filter Variante:', variantId);
        
        const list = productMedia.querySelector('.product__media-list');
        
        // Ausblenden
        if (!isInitialLoad && list) {
          list.classList.add('is-transitioning');
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        let visibleCount = 0;
        
        if (galleryFilenames.length === 0) {
          productMedia.querySelectorAll('[data-media-id]').forEach(item => {
            if (isFirefox) {
              item.style.visibility = 'visible';
              item.style.position = 'relative';
            } else {
              item.style.display = '';
            }
            item.classList.remove('is-filtered');
          });
          visibleCount = productMedia.querySelectorAll('.product__media-item').length;
        } else {
          const filteredMediaIds = [];
          for (const [mediaId, filename] of Object.entries(mediaFilenames)) {
            if (!galleryFilenames.includes(filename)) {
              filteredMediaIds.push(parseInt(mediaId));
            }
          }
          
          // Items filtern
          productMedia.querySelectorAll('.product__media-item[data-media-id]').forEach(item => {
            const mediaId = parseInt(item.getAttribute('data-media-id'));
            const shouldHide = filteredMediaIds.includes(mediaId);
            
            if (isFirefox) {
              if (shouldHide) {
                item.style.visibility = 'hidden';
                item.style.position = 'absolute';
                item.style.pointerEvents = 'none';
                item.classList.add('is-filtered');
              } else {
                item.style.visibility = 'visible';
                item.style.position = 'relative';
                item.style.pointerEvents = '';
                item.classList.remove('is-filtered');
                visibleCount++;
              }
            } else {
              item.style.display = shouldHide ? 'none' : '';
              item.classList.toggle('is-filtered', shouldHide);
              if (!shouldHide) visibleCount++;
            }
          });
          
          // Thumbnails
          productMedia.querySelectorAll('.product__thumbnail-item[data-media-id]').forEach(item => {
            const mediaId = parseInt(item.getAttribute('data-media-id'));
            const shouldHide = filteredMediaIds.includes(mediaId);
            item.style.display = shouldHide ? 'none' : '';
            item.classList.toggle('is-filtered', shouldHide);
          });
          
          // Dots
          productMedia.querySelectorAll('.dots-nav__item[data-media-id]').forEach(item => {
            const mediaId = parseInt(item.getAttribute('data-media-id'));
            const shouldHide = filteredMediaIds.includes(mediaId);
            item.style.display = shouldHide ? 'none' : '';
            item.classList.toggle('is-filtered', shouldHide);
          });
        }
        
        console.log(`✅ ${visibleCount} sichtbar`);
        
        // Flickity Update
        if (productMedia.mainCarousel) {
          try {
            const flickity = await productMedia.mainCarousel.flickityInstance;
            if (flickity) {
              if (visibleCount === 1) {
                flickity.options.draggable = false;
                flickity.options.pageDots = false;
                flickity.options.prevNextButtons = false;
              } else {
                flickity.options.draggable = true;
                flickity.options.pageDots = true;
                flickity.options.prevNextButtons = true;
              }
              
// BEIDE Browser: Gleiche Methode mit extra Delays
flickity.reloadCells();

await new Promise(resolve => setTimeout(resolve, 100));

flickity.resize();

await new Promise(resolve => setTimeout(resolve, 100));

flickity.select(0, false, true);

if (flickity.pageDots) {
  flickity.pageDots.setDots();
}



console.log('✅ Flickity updated');            }
          } catch (e) {
            console.error('❌', e);
          }
        }
// Height Fix falls Viewport auf 0px
const viewport = productMedia.querySelector('.flickity-viewport');
if (viewport && viewport.offsetHeight === 0) {
  if (window.innerWidth > 999) {
    viewport.style.minHeight = '850px';
  } else {
    viewport.style.minHeight = '130vw';
  }
} 

        // Einblenden
        if (list) {
          await new Promise(resolve => setTimeout(resolve, 100));
          list.classList.remove('is-transitioning');
          list.classList.add('is-ready');
        }
        
      } catch (e) {
        console.error('❌', e);
      }
    }
    
    // Initial load
    document.querySelectorAll('product-media').forEach(async (productMedia) => {
      const urlParams = new URLSearchParams(window.location.search);
      let variantId = urlParams.get('variant');
      
      if (!variantId) {
        const formId = productMedia.getAttribute('form-id');
        const form = document.getElementById(formId);
        const input = form?.querySelector('input[name="id"]');
        variantId = input?.value;
      }
      
      if (variantId) {
        const checkFlickity = setInterval(async () => {
          if (productMedia.mainCarousel) {
            clearInterval(checkFlickity);
            await filterGallery(productMedia, variantId, true);
          }
        }, 50);
        
        setTimeout(() => clearInterval(checkFlickity), 3000);
      } else {
        const list = productMedia.querySelector('.product__media-list');
        if (list) list.classList.add('is-ready');
      }
      
      // VARIANTEN-WATCHER: Überwacht Input-Feld Änderungen
      const formId = productMedia.getAttribute('form-id');
      const form = document.getElementById(formId);
      const variantInput = form?.querySelector('input[name="id"]');
      
      if (variantInput) {
        let lastValue = variantInput.value;
        
        // Poll alle 200ms
        setInterval(async () => {
          if (variantInput.value && variantInput.value !== lastValue) {
            console.log('🎯 Wechsel:', lastValue, '→', variantInput.value);
            lastValue = variantInput.value;
            
            // Kurz warten damit Theme seine Updates macht
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Dann filtern
            await filterGallery(productMedia, variantInput.value, false);
          }
        }, 200);
      }
    });
    
    console.log('✅ Script loaded');
  }, 100);
})();